import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { favoritesBoardPath } from "../../../constants/routes";

/**
 * Legacy /favorites URL → Favorites board filter (same cards / betting as
 * the selections window). Keeps old bookmarks and sidebar history working.
 */
const FavoritesRedirect = () => {
  const history = useHistory();

  useEffect(() => {
    history.replace(favoritesBoardPath());
  }, [history]);

  return null;
};

export default FavoritesRedirect;
